import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { useI18n } from "@/i18n/I18nContext";
import { prixConfigures } from "@/lib/roof";

/**
 * Avertissement affiché tant qu'aucun prix n'a été saisi.
 *
 * Un compte neuf arrive avec les POSTES nommés mais tous les montants à zéro :
 * l'outil ne connaît pas le marché du couvreur et ne doit jamais faire semblant.
 * Sans ce bandeau, une soumission partirait à 0 $ sans que personne ne comprenne
 * pourquoi. Autonome (son propre dictionnaire), comme Faq.
 */
const T = {
  fr: {
    titre: "Vos prix ne sont pas encore entrés.",
    corps:
      "Les postes sont là, mais tous les montants sont à zéro : aucune soumission ne peut être chiffrée tant que vous n'avez pas mis VOS prix. Les chiffres gris dans les cases sont des exemples de format — ils ne sont jamais enregistrés.",
    lien: "Entrer mes prix",
  },
  en: {
    titre: "Your prices are not set yet.",
    corps:
      "The line items are there, but every amount is zero: no quote can be priced until you enter YOUR numbers. The grey figures in the fields are format examples only — they are never saved.",
    lien: "Enter my prices",
  },
  es: {
    titre: "Sus precios aún no están ingresados.",
    corps:
      "Las partidas están listas, pero todos los montos están en cero: ninguna cotización puede calcularse hasta que ingrese SUS precios. Las cifras grises en los campos son solo ejemplos de formato — nunca se guardan.",
    lien: "Ingresar mis precios",
  },
};

export default function AlertePrix({ settings, avecLien = true, className = "" }) {
  const { lang } = useI18n();
  if (prixConfigures(settings)) return null;
  const L = T[lang] || T.en;

  return (
    <div
      data-testid="alerte-prix"
      className={`flex gap-3 rounded-xl border border-amber-500/50 bg-amber-500/10 p-4 ${className}`}
    >
      <AlertTriangle className="h-5 w-5 text-amber-500 shrink-0 mt-0.5" />
      <div>
        <p className="font-bold text-ink">{L.titre}</p>
        <p className="text-sm text-ink-soft mt-1">{L.corps}</p>
        {avecLien && (
          <Link
            to="/settings/prix"
            className="inline-block mt-3 text-sm font-bold text-amber-600 dark:text-amber-400 hover:underline"
          >
            {L.lien}
          </Link>
        )}
      </div>
    </div>
  );
}
